import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
    {
        path: 'store',
        loadComponent: () => import('./main/main.component'),
        children: [
          {
            path: 'products',
            title: 'Productos',
            loadComponent: () => import('./main/pages/items/items.component'),
          },
          {
            path: 'products/:id',
            title: 'Producto',
            loadComponent: () => import('./main/pages/items/items.component'),
          },
          {
            path: 'search/:name',
            title: 'Busqueda',
            loadComponent: () => import('./main/pages/search/search.component'),
          },
          {
            path: 'item/:id',
            title: 'Item',
            loadComponent: () => import('./main/pages/item/item.component'),
          },
          {
            path: 'cart',
            title: 'Carrito',
            loadComponent: () => import('./main/pages/cart/cart.component'),
          },
          {
            path: 'finish',
            title: 'Finalizar compra',
            loadComponent: () => import('./main/pages/finish-purchase/finish-purchase.component'),
          },
          {
            path: 'orders',
            title: 'Mis pedidos',
            canActivate: [authGuard],
            loadComponent: () => import('./main/pages/orders/orders.component'),
          },
          {
            // Antes que 'order/:id' no hace falta: Angular compara segmento a
            // segmento y esta tiene uno mas, asi que no compiten.
            path: 'order/:id/detail',
            title: 'Detalle del pedido',
            canActivate: [authGuard],
            loadComponent: () => import('./main/pages/order-detail/order-detail.component'),
          },
          {
            path: 'order/:id',
            title: 'Orden realizada',
            loadComponent: () => import('./main/pages/order-success/order-success.component'),
          },
          {
            path: 'payment/result',
            title: 'Resultado del pago',
            loadComponent: () => import('./main/pages/payment-result/payment-result.component'),
          },
          {
            path: 'login',
            title: 'Login',
            loadComponent: () => import('./main/pages/auth/login/login.component'),
          },
          {
            path: 'forgot-password',
            title: 'Recuperar contraseña',
            loadComponent: () => import('./main/pages/auth/forgot-password/forgot-password.component'),
          },
          {
            path: 'register',
            title: 'Registro',
            loadComponent: () => import('./main/pages/auth/register/register.component'),
          },
          {
            path: 'profile/:id',
            title: 'Perfil',
            loadComponent: () => import('./main/pages/profile/profile.component')
          },   
          {
            path: 'not-found',
            title: 'Página no encontrada',
            loadComponent: () => import('./main/pages/not-found/not-found.component'),
          },
          {
            path:'', redirectTo: 'products', pathMatch: 'full',
          }
        ]
      },
      {
        path: '',
        redirectTo: '/store',
        pathMatch: 'full'
      },
      {
        path: '**',
        redirectTo: '/store/not-found',
      }
];
